import { Component, Input } from '@angular/core';
import { StandaloneActionButton } from './standalone-actions-toolbar.model';
import { TranslateModule } from '@ngx-translate/core';
import { AsyncPipe } from '@angular/common';
import { NbButtonModule } from '@nebular/theme';

@Component({
    selector: 'app-standalone-actions-toolbar',
    styleUrls: ['./standalone-actions-toolbar.component.scss'],
    template: `
    <div class="py-2 px-4 wrapper minHeight">
      @if (leftButton) {
        <button
          nbButton
          class="leftBtn"
          status="primary"
          [outline]="true"
          [disabled]="leftButton.disabled$ | async"
          (click)="leftButton.click()"
          >
          {{ leftButton.text | translate }}
        </button>
      }
    
      @if (rightButton) {
        <button
          nbButton
          class="float-end"
          status="primary"
          [disabled]="rightButton.disabled$ | async"
          (click)="rightButton.click()"
          >
          {{ rightButton.text | translate }}
        </button>
      }
    </div>
    `,
    standalone: true,
    imports: [NbButtonModule, AsyncPipe, TranslateModule]
})
export class StandaloneActionsToolbarComponent {
  @Input() leftButton: StandaloneActionButton;
  @Input() rightButton: StandaloneActionButton;

}
